import {memo, useEffect, useLayoutEffect, useState} from "react";

// react-router-dom components
import {Link, useLocation, useNavigate} from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

import { useDispatch, useSelector } from "react-redux";
import {
    get_auth_info,
    onErrorAlert,
    setDarkMode,
    setLayout,
    setSidenavColor,
    setTransparentSidenav, setWhiteSidenav
} from "../../../actions";
import DashboardNavbar from "../../Navbars/DashboardNavbar";
import LocalStorage from "../../../utils/LocalStorage";
import Fade from "@mui/material/Fade";
import {noop} from "lodash";
import {Alert} from "@mui/material";
import Divider from "@mui/material/Divider";
import MDButton from "../../../components/MDButton";
import {getAllWarehouseList} from "../../../actions/inventory/inventoryAction";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";

const DashboardLayout = memo(({ children }) => {


  return (


          <MDBox>

              {children}

          </MDBox>




  );
})

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
